<template>
  <NuxtLayout :name="layoutName" :navbar-color="layoutNavbarColor">
    <div v-if="story">
      <section class="container authors">
        <BlogBreadcrumbs class="authors__breadcrumbs" />
        <StoryblokComponent :blok="story.content" />
        <div class="authors__grid">
          <BlogAuthorCard
            v-for="author in loadedAuthors"
            :key="author.uuid"
            :author="author"
          />
        </div>
        <div
          v-if="!hideLoadButton"
          ref="loaderEl"
          class="authors__load-section"
        >
          <LoaderSpinner v-if="isLoading && !isError" blue />
          <p v-if="isError" class="authors__error">
            {{ $t('common.something_went_wrong') }}
          </p>
        </div>
      </section>
      <section class="authors__newsletter-section">
        <div class="container">
          <BlogNewsletterCard />
        </div>
      </section>
    </div>
  </NuxtLayout>
</template>

<script lang="ts" setup>
const loaderEl = ref(null)

const queryParams = {
  starts_with: 'blog/authors',
  per_page: 16,
  is_startpage: false,
  sort_by: 'content.name',
}

const {
  initObserver,
  isLoading,
  hideLoadButton,
  loadedElements: loadedAuthors,
  loadFirstPage,
  isError,
} = useLoadMore(queryParams)

const { story } = await useFetchStory('blog/authors')

loadFirstPage()
const { layoutName, layoutNavbarColor } = useStoryLayout<any>(story)

onMounted(() => {
  initObserver(loaderEl.value)
})

watch(loaderEl, () => {
  initObserver(loaderEl.value)
})

const { getBreadcrumbsJsonLd } = useBreadcrumbs()

useCustomHead(story.value, {
  jsonLd: getBreadcrumbsJsonLd(),
})
false && /*#__PURE__*/ defineI18nRoute({
  locales: ['en'],
})
</script>

<style lang="scss" scoped>
.authors {
  padding-bottom: 80px;

  @media (min-width: $breakpoint-lg) {
    padding-bottom: 128px;
  }

  &__grid {
    display: grid;
    grid-template-columns: 1fr;
    row-gap: 48px;

    @media (min-width: $breakpoint-lg) {
      row-gap: 40px;
      column-gap: 52px;
      grid-template-columns: 1fr 1fr;
    }
  }

  &__nav {
    margin: 120px 0;
  }

  &__load-section {
    min-height: 20px;
    width: 100%;
    margin: 40px auto;
    margin: 20px auto 0 auto;
    text-align: center;
  }

  &__newsletter-section {
    background-color: var(--paper-100);
    padding: 80px 0;

    @media (min-width: $breakpoint-md) {
      padding: 128px 0;
    }
  }

  &__error {
    padding-top: 40px;
    display: block;
    font-weight: var(--font-weight-paragraph-bold);
  }
}
</style>
